import { createApi } from "@reduxjs/toolkit/query/react";
import createBaseQuery from "./createBaseQuery";
export function createIPsecApi(baseUrl) {
    const ipsecApi = createApi({
        reducerPath: `ipsecApi_${baseUrl}`,
        baseQuery: createBaseQuery(baseUrl),
        endpoints: (build)=>({
                loadConn: build.mutation({
                    query: (loadConnReq)=>({
                            url: `/api/admin/ipsec/load-conn`,
                            method: "PUT",
                            body: loadConnReq
                        })
                }),
                unloadConn: build.mutation({
                    query: (unloadConnReq)=>({
                            url: `/api/admin/ipsec/unload-conn`,
                            method: "DELETE",
                            body: unloadConnReq
                        })
                }),
                initConn: build.mutation({
                    query: (initArgs)=>({
                            url: `/api/admin/ipsec/init-conn`,
                            method: "POST",
                            body: initArgs
                        })
                }),
                killConn: build.mutation({
                    query: (terminateArgs)=>({
                            url: `/api/admin/ipsec/kill-conn`,
                            method: "POST",
                            body: terminateArgs
                        })
                })
            })
    });
    return ipsecApi;
}
